/* eslint-disable @typescript-eslint/no-unsafe-call */
import React from 'react';
import { ThemeProvider } from 'react-jss';
import { Provider } from 'react-redux';
import { StyledEngineProvider } from '@mui/material';
import { ErrorBoundary } from '@sentry/react';
import * as Sentry from '@sentry/react';
import ReactDOM from 'react-dom/client';
import './assets/fonts/CaslonDoric/CaslonDoric-Semibold-Trial.otf';
import './assets/fonts/HelveticaNeue/HelveticaNeue.ttc';
import './assets/fonts/HelveticaNeue/HelveticaNeueBold.ttf';
import './assets/fonts/HelveticaNeue/HelveticaNeueMedium.ttf';
import './assets/fonts/SfPro/SF-Pro-Text-Regular.otf';
import { theme } from './components/theme';
import { AlertProvider } from './contexts/AlertContext';
import { SocketProvider } from './contexts/SocketContext';
import { MyErrorBoundary } from './ErrorBoundary';
import { ErrorMessage } from './errors/ErrorMessage';
import './index.css';
import { Routing } from './routes';
import { setupStore } from './store/store';

const store = setupStore();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

Sentry.init({
  dsn: 'https://7a48d3e798414912ae5d617b0e8366c4@o4505012199948288.ingest.sentry.io/4505018175062016',
  integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],
  // Performance Monitoring
  tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

root.render(
  <ErrorBoundary fallback={<ErrorMessage />}>
    <MyErrorBoundary>
      <ThemeProvider theme={theme}>
        <AlertProvider>
          <Provider store={store}>
            <SocketProvider>
              <StyledEngineProvider injectFirst>
                <Routing />
              </StyledEngineProvider>
            </SocketProvider>
          </Provider>
        </AlertProvider>
      </ThemeProvider>
    </MyErrorBoundary>
  </ErrorBoundary>,
);
